import { FC, ReactNode } from 'react';
import {
  QueryClient,
  QueryCache,
  MutationCache,
  QueryClientProvider,
} from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { HelmetProvider } from 'react-helmet-async';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { ToastContainer } from '@ui';
import { GlobalStyles } from '@mui/material';
import { toast } from 'react-toastify';
import { isAxiosError } from 'axios';
import i18n from '@i18n/i18n';

import { ThemeProvider } from '@ui/theme';
import { router } from './Router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: true,
    },
  },
  queryCache: new QueryCache(),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isAxiosError(error)) {
        const data = error.response?.data;

        if (typeof data === 'string') {
          console.log(data);
          toast.error(data);
        }
        if (typeof data?.detail === 'string') {
          console.log(data.detail);
          toast.error(data.detail);
        }
        if (Array.isArray(data?.nonFieldErrors)) {
          for (const err of data.nonFieldErrors) {
            toast.error(err);
          }
        }
      }
    },
  }),
});

type Props = {
  children?: ReactNode;
};

export const App: FC<Props> = () => {
  return (
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
          {/* <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          /> */}
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
          />
          <GlobalStyles
            styles={{
              html: {
                height: '100%',
              },
              '#root': {
                height: '100%',
              },

              body: {
                backgroundColor: '#FFFFFF',
                height: '100%',
              },
            }}
          />
        </ThemeProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
};
